<template>
  <div>
    <input
      ref="refInputEl"
      type="file"
      class="d-none"
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      @change="handleUploadChange"
    />
    <b-button
      :variant="!disabledBtn ? 'primary' : 'secondary'"
      class="default-upload-button"
      @click="onUpload"
      :disabled="disabledBtn"
    >
      <div class="d-flex align-items-center">
        <upload-icon class="mr-2" />
        <span>Upload</span>
      </div>
    </b-button>
  </div>
</template>

<script>
import { reactive, getCurrentInstance } from "@vue/composition-api";
import UploadIcon from "@/@core/components/svg/button/Upload.vue";
export default {
  components: {
    UploadIcon,
  },
  props: {
    disabledBtn: { type: Boolean, default: false },
  },
  setup() {
    const vm = getCurrentInstance().proxy;
    const uploadFile = reactive({ file: null, url: null, name: "" });
    const onUpload = () => {
      vm.$refs.refInputEl.click();
    };

    const handleUploadChange = (e) => {
      let filesOBJ = e.target.files[0];
      try {
        let newImageUrl = URL.createObjectURL(filesOBJ);

        uploadFile.file = filesOBJ;
        uploadFile.name = e.target.files[0].name;
        uploadFile.url = newImageUrl;
        vm.$emit("onUpload", uploadFile);
      } catch (err) {
      }
    };

    return {
      onUpload,
      handleUploadChange,
    };
  },
};
</script>

<style scoped>
.default-upload-button {
  padding: 0.5rem 0.8rem;
  border-radius: 0.8rem;
  font-size: 20px;
}

.default-upload-button svg {
  width: 18px;
  fill: var(--button-primary-font);
}
</style>
